var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgramType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21H6.5V10L17.5 21Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10H17.5V21L6.5 10Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02954 9.86515L11.9304 2.02341C11.9396 2.01599 11.9506 2.01011 11.9628 2.00609C11.9749 2.00208 11.9879 2 12.0011 2C12.0143 2 12.0273 2.00208 12.0394 2.00609C12.0516 2.01011 12.0626 2.01599 12.0718 2.02341L21.9705 9.86515C21.9845 9.87618 21.9941 9.89027 21.998 9.90564C22.0019 9.92101 22 9.93695 21.9924 9.95143C21.9848 9.96591 21.9719 9.97826 21.9554 9.98691C21.9389 9.99556 21.9195 10.0001 21.8997 10H2.10027C2.08048 10.0001 2.0611 9.99556 2.04459 9.98691C2.02809 9.97826 2.01521 9.96591 2.00762 9.95143C2.00002 9.93695 1.99805 9.92101 2.00196 9.90564C2.00586 9.89027 2.01546 9.87618 2.02954 9.86515V9.86515Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramType);
export default __webpack_public_path__ + "static/media/programType.34fc52f07467c14467cacb472c7f76f1.svg";
export { ForwardRef as ReactComponent };